"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import type { SolidShapeProps, SolidShapeVariant, SolidShapeVariantProps } from "./solid-shape.types";
import { DiamondSolidShape } from "./variants/diamond";
import { ConcaveSquareSolidShape } from "./variants/concave-square";
import { PinwheelSolidShape } from "./variants/pinwheel";
import { StarburstSolidShape } from "./variants/starburst";
import { SunburstSolidShape } from "./variants/sunburst";
import { QuadrantSolidShape } from "./variants/quadrant";
import { ArchSolidShape } from "./variants/arch";
import { CircleSolidShape } from "./variants/circle";
import { Square1RoundCornerSolidShape } from "./variants/square-1-round-corner";
import { Square2RoundCornerSolidShape } from "./variants/square-2-round-corner";
import { SquircleSolidShape } from "./variants/squircle";
import { RoundedSquareSolidShape } from "./variants/rounded-square";
import { RoundedRectangleStackSolidShape } from "./variants/rounded-rectangle-stack";
import { RoundRectangleStackSolidShape } from "./variants/round-rectangle-stack";
import { HourglassBlockSolidShape } from "./variants/hourglass-block";
const variantMap: Record<SolidShapeVariant, React.ForwardRefExoticComponent<SolidShapeVariantProps & React.RefAttributes<HTMLDivElement>>> = {
  diamond: DiamondSolidShape,
  "concave-square": ConcaveSquareSolidShape,
  pinwheel: PinwheelSolidShape,
  starburst: StarburstSolidShape,
  sunburst: SunburstSolidShape,
  quadrant: QuadrantSolidShape,
  arch: ArchSolidShape,
  circle: CircleSolidShape,
  "square-1-round-corner": Square1RoundCornerSolidShape,
  "square-2-round-corner": Square2RoundCornerSolidShape,
  squircle: SquircleSolidShape,
  "rounded-square": RoundedSquareSolidShape,
  "rounded-rectangle-stack": RoundedRectangleStackSolidShape,
  "round-rectangle-stack": RoundRectangleStackSolidShape,
  "hourglass-block": HourglassBlockSolidShape
};
const SolidShape = React.forwardRef<HTMLDivElement, SolidShapeProps>((t0, ref) => {
  const $ = _c(15);
  let children;
  let className;
  let color;
  let props;
  let t1;
  let variant;
  if ($[0] !== t0) {
    ({
      variant,
      color,
      animated: t1,
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = color;
    $[4] = props;
    $[5] = t1;
    $[6] = variant;
  } else {
    children = $[1];
    className = $[2];
    color = $[3];
    props = $[4];
    t1 = $[5];
    variant = $[6];
  }
  const animated = t1 === undefined ? true : t1;
  const VariantComponent = variantMap[variant];
  let t2;
  if ($[7] !== VariantComponent || $[8] !== animated || $[9] !== children || $[10] !== className || $[11] !== color || $[12] !== props || $[13] !== ref) {
    t2 = <VariantComponent ref={ref} color={color} animated={animated} className={className} {...props}>{children}</VariantComponent>;
    $[7] = VariantComponent;
    $[8] = animated;
    $[9] = children;
    $[10] = className;
    $[11] = color;
    $[12] = props;
    $[13] = ref;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  return t2;
});
SolidShape.displayName = "SolidShape";
export { SolidShape };